import React, { useState } from 'react'
import LayoutMain from '../layouts/LayoutMain'
import MyBlock from '../UI/block/MyBlock'
import { Link } from '@mui/material'
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import MyTextField from '../UI/form/MyTextField';
import MyButton from '../UI/form/MyButton';
import { createQrGoodsAPI } from '../../api/pack/packAPI';
import MyBlockHeader from '../UI/block/MyBlockHeader';
import PackOptions from './options/PackOptions';
import PackList from './PackList';
import SubmenuPacks from './submenu/SubmenuPacks';

const Pack = () => {

  return (
    <LayoutMain>
		<MyBlock>
			<SubmenuPacks />
		</MyBlock>
		{/* <MyBlock>
			<h2>Партії товарів (QR-коди) з замовлення KeyCRM</h2>
		</MyBlock> */}
		<MyBlockHeader
            header={'Партії товарів (QR-коди) з замовлення KeyCRM'}
            options={
                <PackOptions />
            }
        />
		<MyBlock>
			<PackList />
		</MyBlock>
    </LayoutMain>
  )
}

export default Pack